import { useEffect, useCallback } from 'react';

const TimeTrackingListeners = ({ eventEmitter, applyStoreAction }) => {
    const timeTrackingStart = useCallback(timeEntry => {
        applyStoreAction({
            type: 'TIME_ENTRY_START_SOCKET',
            payload: { timeEntry }
        });
    }, [applyStoreAction]);

    const timeTrackingStop = useCallback(timeEntry => {
        applyStoreAction({
            type: 'TIME_ENTRY_STOP_SOCKET',
            payload: {
                timeEntryId: timeEntry.id,
                timeEntry
            }
        });
    }, [applyStoreAction]);

    const timeRecordAdded = useCallback(timeEntry => {
        applyStoreAction({
            type: 'TIME_ENTRY_ADD_SOCKET',
            payload: { timeEntry }
        });
    }, [applyStoreAction]);

    const timeRecordEdited = useCallback(timeEntry => {
        applyStoreAction({
            type: 'TIME_ENTRY_UPDATE_SOCKET',
            payload: {
                timeEntryId: timeEntry.id,
                timeEntry
            }
        });
    }, [applyStoreAction]);

    const timeRecordRemoved = useCallback(({ id: timeEntryId }) => {
        applyStoreAction({
            type: 'TIME_ENTRY_REMOVE_SOCKET',
            payload: { timeEntryId }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('time_tracking_start', timeTrackingStart);
        eventEmitter.on('time_tracking_stop', timeTrackingStop);
        eventEmitter.on('time_record_added', timeRecordAdded);
        eventEmitter.on('time_record_edited', timeRecordEdited);
        eventEmitter.on('time_record_removed', timeRecordRemoved);

        return () => {
            eventEmitter.off('time_tracking_start', timeTrackingStart);
            eventEmitter.off('time_tracking_stop', timeTrackingStop);
            eventEmitter.off('time_record_added', timeRecordAdded);
            eventEmitter.off('time_record_edited', timeRecordEdited);
            eventEmitter.off('time_record_removed', timeRecordRemoved);
        };
    };

    useEffect(listen, [eventEmitter, timeTrackingStart, timeTrackingStop, timeRecordAdded, timeRecordEdited, timeRecordRemoved]);

    return null;
}

export default TimeTrackingListeners;
